import * as yup from "yup";

export const AddPostValidation = yup.object().shape({
  title: yup.string().required("Please enter title."),
  slug: yup
    .string()
    .trim()
    .required("Please enter slug.")
    .matches(
      /^[a-zA-Z0-9][a-zA-Z0-9-_.]*$/,
      "Please enter only English characters with - or _"
    ),
  postType: yup.string().required("Please enter post type."),
  shortDescription: yup.string().required("Please enter a summary."),
  categories: yup
    .array()
    .of(yup.string())
    .required("Please choose atleast one category."),
  featuredImage: yup.string().required("Please choose featured image."),
  description: yup
    .string()
    .required("Please provide description.")
    .test(
      "validateJSONString",
      "Please enter proper description",
      function (value) {
        const { path, createError } = this;
        try {
          const newValue = JSON.parse(value || "");
          const firstBlock = JSON.parse(JSON.stringify(newValue.blocks))[0]
            .type;
          console.log(firstBlock);
          return true;
        } catch (error) {
          if ((error as { message: string }).message.includes("JSON")) {
            const div = document.createElement("div");
            div.innerHTML = value;
            const text = div.textContent || div.innerText || "";
            if (text && text !== "{}") {
              if (text.split(" ").length < 100) {
                return createError({
                  path,
                  message: "Please enter at least 100 words.",
                });
              }
              return true;
            }
          }
          return createError({
            path,
            message: "Please enter proper description.",
          });
        }
      }
    ),
});
